export const defaultState = () => {
  return {
    opening: false,
    windowHeight: 1024,
    windowWidth: 1024,
    displayFeedbackMsg: false,
  };
};

const state = defaultState();

export default state;
